<template>
  <div class="be-wrapper">
    <navbar></navbar>
    <!--<AdBlock :slot-id="1" :count="1" :containerClass="'container xs-pt-30'"></AdBlock>-->
    <router-view></router-view>
    <!--<AdBlock :slot-id="2" :count="2" :containerClass="'container xs-pb-30'"></AdBlock>-->
    <footer-nav></footer-nav>
  </div>
</template>


<script>

  import Navbar from '../navbar/Navbar'
  import FooterNav from '../home/FooterNav'

export default {
  components: {
    Navbar,
    FooterNav
  },
}
</script>

<style lang="scss" scoped>
  .be-wrapper {padding-top:100px !important;font-family:realist, serif;}
</style>



// WEBPACK FOOTER //
// Home.vue?21f7d2c6